export const ATS_NAMES = [
  'INTERNAL',
  'EXTERNAL_URL',
  'KOMBO',
  'BROADBEAN',
  'ARCA24',
  'CANDIDLY',
] as const;
export type SettingsAtsName = (typeof ATS_NAMES)[number];
export type SettingsAtsApplicationMethod = 'INTERNAL' | 'EXTERNAL';

export interface KomboAtsConfig {
  integrationId: string;
}

export type Arca24AtsConfig = Record<string, never>;

export type BroadbeanAtsConfig = Record<string, never>;

export type CandidlyAtsConfig = Record<string, never>;

export interface AccountSettingsAts {
  name: SettingsAtsName;
  config: null | KomboAtsConfig | Arca24AtsConfig | BroadbeanAtsConfig | CandidlyAtsConfig;
  applicationMethod: SettingsAtsApplicationMethod;
  vacancyConfigRequired?: boolean;
}

// the source of truth for this comes from getSupportedApplicationMethods in marketplace-api-core
export const SUPPORTED_APPLICATION_METHODS: Record<
  SettingsAtsName,
  SettingsAtsApplicationMethod | 'INTERNAL_OR_EXTERNAL'
> = {
  INTERNAL: 'INTERNAL',
  CANDIDLY: 'INTERNAL',
  EXTERNAL_URL: 'EXTERNAL',
  KOMBO: 'INTERNAL_OR_EXTERNAL',
  BROADBEAN: 'INTERNAL_OR_EXTERNAL',
  ARCA24: 'INTERNAL_OR_EXTERNAL',
};

// the source of truth for this list is IsExternalApplicationUrlRequiredValidator in marketplace-api-core
export const ATS_WITH_EXTERNAL_URL_REQUIRED: readonly SettingsAtsName[] = ATS_NAMES.filter(
  (atsName) => SUPPORTED_APPLICATION_METHODS[atsName] !== 'INTERNAL'
);
